import apiBaseUrl from './url'
import axios from 'axios'

const request = (path, opts) => {
  opts = Object.assign({ method: 'get' }, opts, {
    url: `${apiBaseUrl}${path}`,
  })
  return axios(opts).then(EnsureOk)
}

const EnsureOk = response => {
  return new Promise((resolve, reject) => {
    if (response.status >= 200 && response.status < 300) {
      resolve(response)
    } else {
      const error = new Error(`HTTP Error ${response.status}`)
      error.response = response
      reject(error)
    }
  })
}

export default request
